import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminCategoryMapping from "@/pages/admin/AdminCategoryMapping";

export const Route = createFileRoute("/admin/category-mapping")({
  component: () => (
    <ProtectedRoute>
      <AdminCategoryMapping />
    </ProtectedRoute>
  ),
});
